<div class="val-facture-achat-fiche-contenu-body">

  @if (!donnees) {
    <div class="val-flex-conteneur val-flex-colonne">
      <val-fonte-icone iconeCss="far fa-frown"></val-fonte-icone>
      <val-simple-libelle [libelle]="'achat.fiche.inaccessible' | transloco"></val-simple-libelle>
    </div>
  }
  @else
  {
    <val-barre-onglets #barreOnglets
                       [onglets]="onglets"
                       (ongletSelectionneChange)="OngletSelectionneChange($event)"
                       (rafraichissementOngletDemande)="RafraichissementOngletDemande($event)">
    </val-barre-onglets>

    @if (barreOnglets.GetIdentifiantOngletSelectionne() === 'details')
    {
    <table style="table-layout: fixed; width: 100%;"></table> <!-- Permet de forcer la pleine largeur, en attendant une grille -->

    <val-simple-panel>
      <div class="val-flex-conteneur">
        <div class="val-facture-achat-fiche-synthese-entete-conteneur val-flex-conteneur val-flex-colonne val-flex-2">
          <div class="val-flex-conteneur">
            <val-fonte-icone iconeCss="far fa-calendar-week"></val-fonte-icone>
            <val-simple-libelle class="val-facture-achat-fiche-synthese-entete-libelle"
              [libelle]="'achat.fiche.synthese.date-facture' | transloco"></val-simple-libelle>
            <val-simple-libelle class="val-facture-achat-fiche-synthese-entete-libelle-contenu"
              [libelle]="donnees.dateFacture | translocoDate"></val-simple-libelle>
          </div>
          <div class="val-flex-conteneur">
            <val-fonte-icone iconeCss="far fa-code-branch"></val-fonte-icone>
            <val-simple-libelle class="val-facture-achat-fiche-synthese-entete-libelle"
              [libelle]="'achat.fiche.synthese.processus-metier' | transloco"></val-simple-libelle>
            <val-simple-libelle class="val-facture-achat-fiche-synthese-entete-libelle-contenu"
              [libelle]="donnees.processusMetier"></val-simple-libelle>
          </div>
          <div class="val-flex-conteneur">
            <val-fonte-icone iconeCss="far fa-building"></val-fonte-icone>
            <val-simple-libelle class="val-facture-achat-fiche-synthese-entete-libelle"
              [libelle]="'achat.commun.vendeur' | transloco"></val-simple-libelle>
            <val-simple-libelle class="val-facture-achat-fiche-synthese-entete-libelle-contenu"
              [libelle]="donnees.vendeur"></val-simple-libelle>
          </div>
        </div>

        <div class="val-flex-1">

        </div>

        <div class="val-facture-achat-fiche-synthese-montant-conteneur val-flex-conteneur val-flex-colonne val-flex-1">
          <div class="val-facture-achat-fiche-synthese-montant-zone-conteneur val-flex-conteneur val-flex-colonne">
            <val-simple-libelle [libelle]="'achat.fiche.synthese.montant-ttc' | transloco"></val-simple-libelle>
            <val-simple-libelle class="val-facture-achat-fiche-synthese-montant-zone-valeur"
              [libelle]="donnees.montantTtc | translocoCurrency"></val-simple-libelle>
          </div>
          <div class="val-flex-conteneur">
            <val-fonte-icone iconeCss="far fa-calendar-week"></val-fonte-icone>
            <val-simple-libelle [libelle]="'achat.fiche.synthese.echeance' | transloco: { date: (donnees.dateEcheance | translocoDate) }"></val-simple-libelle>
          </div>
        </div>
      </div>
    </val-simple-panel>

        <div class="val-facture-achat-fiche-row val-flex-conteneur">
      <val-simple-panel class="val-flex-1">
        <div class="val-facture-achat-fiche-informations-conteneur">
          <div class="val-facture-achat-fiche-informations-title val-flex-conteneur">
            <val-fonte-icone iconeCss="far fa-file-invoice"></val-fonte-icone>
            <val-simple-libelle [libelle]="'achat.fiche.informations.titre' | transloco"></val-simple-libelle>
          </div>
          <div class="val-facture-achat-fiche-informations-row val-flex-conteneur val-flex-colonne">
            <div class="val-flex-conteneur">
              <val-simple-libelle class="val-facture-achat-fiche-informations-contenu-libelle"
                [libelle]="'achat.fiche.informations.reference' | transloco"></val-simple-libelle>
              <val-simple-libelle class="val-facture-achat-fiche-informations-contenu"
                [libelle]="donnees.reference"></val-simple-libelle>
            </div>
            <div class="val-flex-conteneur">
              <val-simple-libelle class="val-facture-achat-fiche-informations-contenu-libelle"
                [libelle]="'achat.commun.date' | transloco"></val-simple-libelle>
              <val-simple-libelle class="val-facture-achat-fiche-informations-contenu"
                [libelle]="donnees.dateFacture | translocoDate"></val-simple-libelle>
            </div>
            <div class="val-flex-conteneur">
              <val-simple-libelle class="val-facture-achat-fiche-informations-contenu-libelle"
                [libelle]="'achat.fiche.informations.processus' | transloco"></val-simple-libelle>
              <val-simple-libelle class="val-facture-achat-fiche-informations-contenu"
                [libelle]="donnees.processusMetier"></val-simple-libelle>
            </div>
            <div class="val-flex-conteneur">
              <val-simple-libelle class="val-facture-achat-fiche-informations-contenu-libelle"
                [libelle]="'achat.fiche.informations.type-piece' | transloco"></val-simple-libelle>
              <val-simple-libelle class="val-facture-achat-fiche-informations-contenu"
                [libelle]="donnees.typePiece"></val-simple-libelle>
            </div>
            @if (donnees.referenceFactureOrigine)
            {
              <div class="val-flex-conteneur">
                <val-simple-libelle class="val-facture-achat-fiche-informations-contenu-libelle"
                  [libelle]="'achat.fiche.informations.facture-origine' | transloco"></val-simple-libelle>
                <val-simple-libelle class="val-facture-achat-fiche-informations-contenu"
                  [libelle]="donnees.referenceFactureOrigine"></val-simple-libelle>
              </div>
            }
          </div>

          <div class="val-facture-achat-fiche-informations-separateur"></div>

          <div class="val-facture-achat-fiche-informations-title val-flex-conteneur">
            <val-fonte-icone iconeCss="far fa-building"></val-fonte-icone>
            <val-simple-libelle [libelle]="'achat.commun.vendeur' | transloco"></val-simple-libelle>
          </div>
          <div class="val-facture-achat-fiche-informations-row val-flex-conteneur val-flex-colonne">
            <div class="val-flex-conteneur">
              <val-simple-libelle class="val-facture-achat-fiche-informations-contenu-libelle"
                [libelle]="'achat.fiche.vendeur.raison-sociale' | transloco"></val-simple-libelle>
              <val-simple-libelle class="val-facture-achat-fiche-informations-contenu"
                [libelle]="donnees.vendeur"></val-simple-libelle>
            </div>
            <div class="val-flex-conteneur">
              <val-simple-libelle class="val-facture-achat-fiche-informations-contenu-libelle"
                [libelle]="'achat.fiche.vendeur.identifiant-adressage' | transloco"></val-simple-libelle>
              <val-simple-libelle class="val-facture-achat-fiche-informations-contenu"
                [libelle]="donnees.identifiantAdressageVendeur"></val-simple-libelle>
            </div>
            <div class="val-flex-conteneur">
              <val-simple-libelle class="val-facture-achat-fiche-informations-contenu-libelle"
                [libelle]="'achat.fiche.vendeur.identifiant-complementaire' | transloco"></val-simple-libelle>
              <val-simple-libelle class="val-facture-achat-fiche-informations-contenu"
                [libelle]="donnees.identifiantComplementaireVendeur"></val-simple-libelle>
            </div>
          </div>
        </div>
      </val-simple-panel>


      <val-simple-panel class="val-flex-1">
        <div class="val-facture-achat-fiche-montants-conteneur">
          <div class="val-facture-achat-fiche-montants-title val-flex-conteneur">
            <val-fonte-icone iconeCss="far fa-money-bill-alt"></val-fonte-icone>
            <val-simple-libelle [libelle]="'achat.fiche.montants.titre' | transloco"></val-simple-libelle>
          </div>

          <div class="val-facture-achat-fiche-montants-montant-conteneur val-flex-conteneur">
              <div class="val-facture-achat-fiche-montants-montant-zone montant-ht val-flex-conteneur val-flex-colonne val-flex-1">
                <val-simple-libelle class="val-facture-achat-fiche-montants-montant-zone-valeur"
                  [libelle]="donnees.montantHt | translocoCurrency"></val-simple-libelle>
                <val-simple-libelle [libelle]="'achat.fiche.montants.ht' | transloco"></val-simple-libelle>
              </div>

              <div class="val-facture-achat-fiche-montants-montant-zone montant-tva val-flex-conteneur val-flex-colonne val-flex-1">
                <val-simple-libelle class="val-facture-achat-fiche-montants-montant-zone-valeur"
                  [libelle]="donnees.montantTva | translocoCurrency"></val-simple-libelle>
                <val-simple-libelle [libelle]="'achat.fiche.montants.tva' | transloco"></val-simple-libelle>
              </div>

              <div class="val-facture-achat-fiche-montants-montant-zone montant-ttc val-flex-conteneur val-flex-colonne val-flex-1">
                <val-simple-libelle class="val-facture-achat-fiche-montants-montant-zone-valeur"
                  [libelle]="donnees.montantTtc | translocoCurrency"></val-simple-libelle>
                <val-simple-libelle [libelle]="'achat.fiche.montants.ttc' | transloco"></val-simple-libelle>
              </div>
          </div>

          <div class="val-facture-achat-fiche-montants-separateur"></div>

          <div class="val-flex-conteneur">
            <val-fonte-icone iconeCss="far fa-credit-card-blank"></val-fonte-icone>
            <val-simple-libelle class="val-facture-achat-fiche-montants-contenu-libelle"
              [libelle]="'achat.fiche.montants.acompte' | transloco"></val-simple-libelle>
            <val-simple-libelle class="val-facture-achat-fiche-montants-contenu"
              [libelle]="donnees.montantAcompte | translocoCurrency"></val-simple-libelle>
          </div>

          <div class="val-facture-achat-fiche-montants-separateur"></div>

          <div class="val-flex-conteneur">
            <val-fonte-icone iconeCss="far fa-file-invoice-dollar"></val-fonte-icone>
            <val-simple-libelle class="val-facture-achat-fiche-montants-contenu-libelle"
              [libelle]="'achat.fiche.montants.net-a-payer' | transloco"></val-simple-libelle>
            <val-simple-libelle class="val-facture-achat-fiche-montants-contenu"
              [libelle]="donnees.montantNetAPayer | translocoCurrency"></val-simple-libelle>
          </div>

          <div class="val-facture-achat-fiche-montants-separateur"></div>

          <div class="val-flex-conteneur">
            <val-fonte-icone iconeCss="far fa-calendar-week"></val-fonte-icone>
            <val-simple-libelle class="val-facture-achat-fiche-montants-contenu-libelle"
              [libelle]="'achat.fiche.montants.date-echeance' | transloco"></val-simple-libelle>
            <val-simple-libelle class="val-facture-achat-fiche-montants-contenu blue"
              [libelle]="donnees.dateEcheance | translocoDate"></val-simple-libelle>
            <val-simple-libelle class="val-facture-achat-fiche-montants-contenu gray"
              [libelle]="'achat.fiche.montants.jours-avant-echeance' | transloco: { nombre: donnees.nombreJoursAvantEcheance }"></val-simple-libelle>
          </div>
        </div>
      </val-simple-panel>
    </div>
    }

    @if (barreOnglets.GetIdentifiantOngletSelectionne() === 'documents')
    {
    <div class="val-facture-achat-fiche-documents-conteneur val-flex-conteneur">
      <val-simple-panel class="val-flex-1">
        <div class="val-facture-achat-fiche-documents-grille-conteneur">
          <val-grille [colonnes]="colonnes_documents"
                      champSelection="id"
                      [donnees]="donnees_documents"
                      [simpleSelection]="true"
                      [menuColonne]="false"
                      [colonneSelection]="false"
                      (selectionChange)="DocumentSelectionChange($event)"
                      (colonneBoutonIconeClick)="DocumentColonneBoutonIconeClick($event)">
          </val-grille>
        </div>
      </val-simple-panel>
      @if (documentSelectionne)
      {
        <val-simple-panel class="val-flex-1">
          <div class="val-facture-achat-fiche-pdf-viewer-conteneur">
            <kendo-pdfviewer [url]="urlDocumentSelectionne"
                             [saveFileName]="nomFichierDocumentSelectionne"
                             [tools]="['search', 'selection', 'zoomInOut', 'spacer', 'pager', 'download', 'print']"
                             [zoom]="1">
            </kendo-pdfviewer>
          </div>
        </val-simple-panel>
      }
    </div>
    }

    @if (barreOnglets.GetIdentifiantOngletSelectionne() === 'historique')
    {
    <div class="val-facture-achat-fiche-historique-conteneur val-flex-conteneur"
         [class.val-facture-achat-fiche-historique-avec-retour]="afficherRetourAcheteur && retourAcheteurSelectionne">
      <val-simple-panel class="val-flex-1">
        <div class="val-facture-achat-fiche-historique-grille-conteneur">
          <val-grille #grilleHistorique
                      [colonnes]="colonnes_historique"
                      champSelection="id"
                      [donnees]="donnees_historique"
                      [simpleSelection]="true"
                      [menuColonne]="false"
                      [colonneSelection]="false"
                      (selectionChange)="HistoriqueSelectionChange($event)">
          </val-grille>
        </div>

        @if (afficherRetourAcheteur && retourAcheteurSelectionne)
        {
        <val-simple-panel class="val-facture-achat-fiche-historique-retour-acheteur-panel" couleurFond="#F9EBE8" couleurBord="#b5141e" couleurTitre="#b5141e">
          <div class="val-facture-achat-fiche-historique-retour-acheteur-conteneur">
            <div class="val-facture-achat-fiche-historique-title val-flex-conteneur">
              <val-fonte-icone iconeCss="fas fa-bell" couleurIcone="#b5141e"></val-fonte-icone>
              <val-simple-libelle [libelle]="'achat.fiche.retour-acheteur.titre' | transloco"></val-simple-libelle>
            </div>
            <div class="val-facture-achat-fiche-historique-retour-acheteur-row val-flex-conteneur val-flex-colonne">
              <div class="val-flex-conteneur">
                <val-simple-libelle class="val-facture-achat-fiche-historique-retour-acheteur-libelle" [libelle]="'achat.commun.motif' | transloco"></val-simple-libelle>
                <val-simple-libelle [libelle]="retourAcheteurSelectionne.motif"></val-simple-libelle>
              </div>
              <div class="val-flex-conteneur">
                <val-simple-libelle class="val-facture-achat-fiche-historique-retour-acheteur-libelle" [libelle]="'achat.fiche.retour-acheteur.description' | transloco"></val-simple-libelle>
                <val-simple-libelle [libelle]="retourAcheteurSelectionne.motifDescription"></val-simple-libelle>
              </div>
              <div class="val-flex-conteneur">
                <val-simple-libelle class="val-facture-achat-fiche-historique-retour-acheteur-libelle" [libelle]="'achat.fiche.retour-acheteur.note' | transloco"></val-simple-libelle>
                <div class="val-flex-conteneur val-flex-colonne">
                  @for (ligne of ParseNote(retourAcheteurSelectionne.note); track ligne) {
                  <val-simple-libelle [libelle]="ligne"></val-simple-libelle>
                  }
                </div>
              </div>
            </div>
          </div>
        </val-simple-panel>
        }
      </val-simple-panel>
    </div>
    }

  <val-attente-operation [visible]="operationEnCours"></val-attente-operation>
  }

</div>
